import Draft from "draft-js";
import { DraftEntityOption } from "@sonder/editor/typings/editor";

/**
 * Get a list of all entity instances of the given type
 */
export const getEntityDataByType = (
  content: Draft.ContentState,
  entityType: string,
): DraftEntityOption[] => {
  const entities: DraftEntityOption[] = [];
  content.getBlocksAsArray().forEach(block => {
    let entityData: DraftEntityOption | null = null;
    block.findEntityRanges(
      character => {
        const entityKey = character.getEntity();
        const entity = entityKey ? content.getEntity(entityKey) : null;
        if (entityKey && entity && entityType === entity.getType()) {
          entityData = {
            type: entity.getType(),
            mutability: entity.getMutability(),
            data: entity.getData(),
          };
          return true;
        }
        entityData = null;
        return false;
      },
      () => {
        if (entityData) entities.push(entityData);
      },
    );
  });

  return entities;
};
